import { render, staticRenderFns } from "./EmployeeCountDashboard.vue?vue&type=template&id=d0af3860&scoped=true&"
import script from "./EmployeeCountDashboard.vue?vue&type=script&lang=js&"
export * from "./EmployeeCountDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0af3860",
  null
  
)

export default component.exports